import React from "react";
import TeamSection from "../../Components/TeamSection/TeamSection";

function TeamSectionPage(props) {
  return (
    <div>
      <TeamSection name={"Matt B"} />
      <TeamSection name={"Mattey"} />
    </div>
  );
}

export default TeamSectionPage;
